import type { FAQContent } from '@/core/types';

import { FAQ } from '@/containers/blocks/features';

type FAQGeneratorProps = {
  content: FAQContent;
  className?: string;
};

export default function FAQGenerator({ content, className }: FAQGeneratorProps) {
  return <FAQ faqs={content.faqs} className={className} />;
}
